import React from 'react';
import { ShieldOff } from 'lucide-react';

const PermissionNoticeCard = ({
  title = 'Access Restricted',
  message = 'You currently do not have permission from your Organization Head or Organization Admin to access this feature.',
  hint = 'Only the specific feature is blocked. Your layout, profile, and other permitted areas remain available.',
}) => {
  return (
    <div className="mx-auto max-w-2xl rounded-3xl border bg-white p-6 text-center shadow-sm" style={{ borderColor: '#f4d6df' }}>
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl" style={{ background: '#fce0e8' }}>
        <ShieldOff size={26} style={{ color: '#c44569' }} />
      </div>
      <h2 className="text-lg font-bold text-slate-900">{title}</h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-600">{message}</p>
      <p className="mt-3 text-xs text-slate-400">{hint}</p>
    </div>
  );
};

export default PermissionNoticeCard;